var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.57.9H1.43C.74.9.18 1.46.18 2.15v.29c0 .69.56 1.25 1.25 1.25h14.14c.69 0 1.25-.56 1.25-1.25v-.29c0-.69-.56-1.25-1.25-1.25Zm0 6.71H1.43c-.69 0-1.25.56-1.25 1.25v.29c0 .69.56 1.25 1.25 1.25h14.14c.69 0 1.25-.56 1.25-1.25v-.29c0-.69-.56-1.25-1.25-1.25Zm-14.14 6.7h14.14c.69 0 1.25.56 1.25 1.25v.29c0 .69-.56 1.25-1.25 1.25H1.43c-.69 0-1.25-.56-1.25-1.25v-.29c0-.69.56-1.25 1.25-1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ce2a68fedb1650da90368bd5d5864de6.svg";
export { ForwardRef as ReactComponent };